export default __webpack_public_path__ + "static/media/Private_Equity_20230531.039fd17d.pdf";